/**
 * VariableChips — chips de variáveis de personalização para composers.
 *
 * Clique insere o placeholder no texto; o backend resolve NO ENVIO, por
 * destinatário (services/message_variables.py). Mesmo contrato nos 4 canais
 * e nas automações (mensagem pronta, follow-up, disparo, campanha).
 */
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

export const MESSAGE_VARIABLES = [
  { token: '{{primeiro_nome}}', label: 'Primeiro nome' },
  { token: '{{nome}}', label: 'Nome completo' },
  { token: '{{saudacao}}', label: 'Saudação (Bom dia...)' },
  { token: '{{responsavel}}', label: 'Responsável' },
  { token: '{{telefone}}', label: 'Telefone' },
  { token: '{{data}}', label: 'Data' },
  { token: '{{hora}}', label: 'Hora' },
];

/**
 * props:
 *   onInsert(token) — obrigatório; insere o token no composer do caller.
 *   showCustomFieldHint — mostra a dica do {{campo:Nome}} (default true).
 *   style — overrides do container.
 */
const VariableChips = ({ onInsert, showCustomFieldHint = true, style }) => {
  const { colors } = useTheme();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, ...style }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
        <span style={{ fontSize: 11, color: colors.textTertiary, fontWeight: 600 }}>
          Variáveis:
        </span>
        {MESSAGE_VARIABLES.map((v) => (
          <button
            key={v.token}
            type="button"
            title={`Inserir ${v.token} — vira "${v.label}" do contato no envio`}
            onClick={() => onInsert?.(v.token)}
            style={{
              fontSize: 11,
              padding: '3px 8px',
              borderRadius: 999,
              border: `1px solid ${colors.borderColor}`,
              backgroundColor: colors.bgSecondary,
              color: colors.textSecondary,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {v.label}
          </button>
        ))}
      </div>
      {showCustomFieldHint && (
        <span style={{ fontSize: 10.5, color: colors.textTertiary }}>
          Campo personalizado: escreva {'{{campo:Nome do campo}}'} (ex.:{' '}
          {'{{campo:Veículo}}'}). O valor de cada contato entra na hora do envio.
        </span>
      )}
    </div>
  );
};

export default VariableChips;
